import axios from "../utility/authAxios";
import { API_VERSION, SAAS_SERVICE_PATH } from "../config/axios";
import { setHttpParams } from "../utility/utils";

const url = `${API_VERSION}/${SAAS_SERVICE_PATH}/trip-route`;

/**************** Station API *****************************/
/**
 * get all station
 * @param params => {orderBy, sortBy, pageOffset, page, search}
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getAll = async (params = {}) => {
    params = setHttpParams(params);
    return axios.get(`${url}?${params}`);
};
export const getAllWithoutPagination = async (params = {}) => {
    params = setHttpParams(params);
    return axios.get(`${url}/all?${params}`);
};

export const getTripRoutesByCompany = async (companyId) => {
    const { data } = await getAllWithoutPagination({
        company: companyId,
        order_by: "title_en",
        direction: "ASC",
    });
    return data.data;
};

export const get = async (id) => {
    return axios.get(`${url}/${id}`);
};

export const getPermissions = async () => {
    return axios.get(API_VERSION + `/permissions`);
};

export const create = async (data) => {
    return axios.post(`${url}`, data);
};

export const update = async (id, data) => {
    return axios.put(`${url}/${id}`, data);
};

export const remove = async (id) => {
    return axios.delete(`${url}/${id}`);
};
